/* Ordine «In evidenza» del catalogo e della vetrina in home (richiesta di Eleonora, 16/10).
   1. In apertura i pezzi scelti qui sotto: oro, diamanti e pietre, sotto gli 8.000 € (l'alta gioielleria resta a parte).
   2. Poi tutti gli altri gioielli in oro, nell'ordine di prima.
   3. Per ultimi argento e argento dorato, nell'ordine di prima.
   Per cambiare i primi pezzi basta modificare la lista IN_APERTURA (gli handle dei prodotti, nell'ordine voluto). */
(function () {
  var IN_APERTURA = [
    'anello-glowra', 'orecchini-auras', 'bracciale-linear-luxe-in-oro-rosa', 'pendente-blue-orbit',
    'anello-diamond-skies', 'orecchini-whispers-in-gold', 'bracciale-regalia', 'anello-athenia',
    'orecchini-luna-loops', 'anello-evergold', 'collana-echo-in-gold', 'orecchini-elesia'
  ];
  var D = window.EM_DATI;
  if (!D || !D.x) return;
  var x = D.x;
  var oro = function (h) { return (x[h][2] || []).some(function (m) { return m.indexOf('Oro') === 0; }); };
  var resto = Object.keys(x).filter(function (h) { return IN_APERTURA.indexOf(h) < 0; })
    .sort(function (a, b) { return x[a][0] - x[b][0]; });
  IN_APERTURA.forEach(function (h, i) { if (x[h]) x[h][0] = -100 + i; });
  resto.filter(oro).concat(resto.filter(function (h) { return !oro(h); }))
    .forEach(function (h, i) { x[h][0] = i; });
})();
